// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3lh8X","header":"ReportDetails_header__2B_8-","title":"ReportDetails_title__MlMNr","left":"ReportDetails_left__AVPGB"};